export interface CancellationReason {
  id: number;
  name: string;
  type: CancellationType;
  isVisible?: boolean;
}

export enum CancellationType {
  Order = 1,
  Subscription = 2,
}
